import type { TaskAppointmentType, TaskBusinessState, TaskRequestContext, TaskRoutingState, TaskWorkType } from '@/types/task';

export const CPT_CODE_OPTIONS = [
  '93260', '93261', '93279', '93280', '93281', '93282', '93283', '93284',
  '93291', '93296', '93297-TC', '93298-TC', 'Combo',
].map((c) => ({ value: c, label: c }));

export const IN_CLINIC_CPT_OPTIONS = [
  '93279', '93280', '93281', '93282', '93283', '93284', '93260', '93261', '93291',
].map((c) => ({ value: c, label: c }));

export const APPOINTMENT_TYPE_OPTIONS: { value: TaskAppointmentType; label: string }[] = [
  { value: 'routine_billable', label: 'Routine billable' },
  { value: 'alert_billable', label: 'Alert billable' },
  { value: 'alert_non_billable', label: 'Alert, non-billable' },
  { value: 'non_billable', label: 'Non-billable' },
  { value: 'in_clinic', label: 'In clinic' },
  { value: 'unknown', label: 'Unknown' },
];

export function appointmentTypeLabel(value?: string | null): string {
  if (!value) return '—';
  return APPOINTMENT_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

export const ROUTING_STATE_LABEL: Record<TaskRoutingState, string> = {
  blocked: 'Blocked',
  ready: 'Ready',
  offered: 'Offered',
  assigned: 'Assigned',
};

export const STATUS_META: Record<TaskBusinessState, { label: string; color: string }> = {
  open: { label: 'Open', color: 'blue' },
  in_progress: { label: 'In Progress', color: 'violet' },
  on_hold: { label: 'On Hold', color: 'yellow' },
  completed: { label: 'Completed', color: 'teal' },
  canceled: { label: 'Canceled', color: 'gray' },
};

export const CATEGORY_LABEL: Record<TaskWorkType, string> = {
  clinical: 'Clinical',
  admin: 'Admin',
  patient_support: 'Patient Support',
  billing: 'Billing',
};

export const CATEGORY_COLOR: Record<TaskWorkType, string> = {
  clinical: 'teal',
  admin: 'indigo',
  patient_support: 'cyan',
  billing: 'yellow',
};

export const QUEUE_FOR: Record<TaskWorkType, string> = {
  clinical: 'TT Triage Queue',
  admin: 'Admin Queue',
  patient_support: 'Patient Support Queue',
  billing: 'Billing Queue',
};

export const CLINICAL_TYPES = [
  'Routine',
  'Heart Failure',
  'Combo',
  'ERI Tracking',
  'Physician Requested',
];

export const ADMIN_TYPES = [
  'Check-In',
  'Disconnected',
  'Gen Change',
  'New Monitor Set Up',
  'No Show',
  'Reactivation',
  'Report Uploaded',
  'Schedule Adjustment',
  'Transfer',
  'Deactivate Patient',
  'Re-engagement',
  'Patient Outreach Request',
];

export const REQUEST_CONTEXT_OPTIONS: { value: TaskRequestContext; label: string }[] = [
  { value: 'Transmission Request', label: 'Transmission Request' },
  { value: 'Physician Transmission Request', label: 'Physician Transmission Request' },
  { value: 'Patient Outreach Request', label: 'Patient Outreach Request' },
];

export const CALL_TYPES = ['Inbound Call', 'Outbound Campaign Call', 'Manual Outbound Call'];
export const INBOUND_CALL_TYPES = ['Inbound Call'];
export const OUTBOUND_CALL_TYPES = ['Outbound Campaign Call', 'Manual Outbound Call'];
